import React, { memo } from 'react';
import { Button, Card, LoadingButton, Stack, Typography } from 'investira.react.components';
import { wOtpGestorEtapas, wOtpGestorModos } from './avaliacoesGestorEdit.constants';

const AvaliacoesGestorEditOtpView = memo(props => {
  const {
    otp,
    onSolicitarOtp,
    onSubmitOtp,
    onChangeOtp,
    onKeyDownOtp,
    onPasteOtp,
    onReenviarOtp,
    onClearOtp
  } = props;

  return (
    <Card sx={{ p: 4 }}>
      {otp.status.etapa === wOtpGestorEtapas.solicitar ? (
        <Stack alignItems="center" justifyContent="center" gap={2} sx={{ minHeight: 240 }}>
          <Stack gap={1} alignItems="center" sx={{ maxWidth: 360 }}>
            <Typography variant="h5" color="textPrimary" sx={{ textAlign: 'center' }}>
              Solicite o código de acesso
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center' }}>
              Você receberá em seu e-mail o código de 6 dígitos para liberar o preenchimento da
              avaliação.
            </Typography>
          </Stack>
          <LoadingButton
            data-testid="otp-gestor-request"
            variant="contained"
            type="button"
            onClick={onSolicitarOtp}
            disabled={otp.status.modo !== wOtpGestorModos.idle}
            sx={{
              minWidth: 280,
              borderRadius: '999px',
              py: 1.5,
              px: 4,
              fontWeight: 700
            }}>
            Solicitar código de acesso
          </LoadingButton>
        </Stack>
      ) : (
        <Stack data-testid="otp-gestor-verification" gap={3} alignItems="center">
          <Stack gap={1} alignItems="center">
            <Typography variant="h5" color="textPrimary" sx={{ textAlign: 'center' }}>
              Verifique o código de acesso
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', maxWidth: 360 }}>
              Digite os 6 dígitos enviados para o seu e-mail para liberar o preenchimento da
              avaliação.
            </Typography>
          </Stack>

          <form data-testid="otp-gestor-form" onSubmit={onSubmitOtp} style={{ width: '100%' }}>
            <Stack gap={2} alignItems="center">
              <div
                data-testid="otp-gestor-input"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  width: '100%',
                  flexWrap: 'nowrap'
                }}>
                {otp.digitos.map((pDigito, pIndex) => {
                  const xTemErro = Boolean(otp.status.erro);

                  return (
                    <input
                      key={`otp-${pIndex}`}
                      ref={pElement => {
                        otp.inputRefs.current[pIndex] = pElement;
                      }}
                      data-testid={`otp-gestor-digit-${pIndex}`}
                      aria-label={`Dígito ${pIndex + 1} do código de acesso`}
                      autoComplete={pIndex === 0 ? 'one-time-code' : 'off'}
                      inputMode="numeric"
                      maxLength={1}
                      onChange={pEvent => onChangeOtp(pIndex, pEvent)}
                      onKeyDown={pEvent => onKeyDownOtp(pIndex, pEvent)}
                      onPaste={pEvent => onPasteOtp(pIndex, pEvent)}
                      value={pDigito}
                      style={{
                        width: '48px',
                        height: '56px',
                        borderRadius: '12px',
                        border: xTemErro ? '1px solid #d32f2f' : '1px solid #c4c4c4',
                        fontSize: '24px',
                        fontWeight: 700,
                        textAlign: 'center'
                      }}
                    />
                  );
                })}
              </div>

              <Typography variant="caption" color="textSecondary">
                {otp.cooldownAtivo
                  ? `Reenviar código em ${otp.formatarCooldown(otp.cooldownRestanteMs)}`
                  : 'Você já pode reenviar o código caso necessário.'}
              </Typography>

              {otp.status.erro ? (
                <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 500 }}>
                  {otp.status.erro}
                </Typography>
              ) : null}

              <Stack direction="row" justifyContent="center" gap={1} flexWrap="wrap">
                <Button
                  data-testid="otp-gestor-resend"
                  variant="text"
                  type="button"
                  onClick={onReenviarOtp}
                  disabled={!otp.podeReenviar}>
                  Reenviar código
                </Button>
                <Button
                  data-testid="otp-gestor-clear"
                  variant="text"
                  type="button"
                  onClick={onClearOtp}
                  disabled={!otp.codigo && !otp.status.erro}>
                  Limpar
                </Button>
                <LoadingButton
                  data-testid="otp-gestor-submit"
                  loading={otp.status.modo === wOtpGestorModos.validando}
                  variant="contained"
                  type="submit"
                  disabled={!otp.podeValidar}>
                  Acessar
                </LoadingButton>
              </Stack>
            </Stack>
          </form>
        </Stack>
      )}
    </Card>
  );
});

export default AvaliacoesGestorEditOtpView;
